import { render, staticRenderFns } from "./EditPriceDlg.vue?vue&type=template&id=d4375c3e&scoped=true"
import script from "./EditPriceDlg.vue?vue&type=script&lang=js"
export * from "./EditPriceDlg.vue?vue&type=script&lang=js"
import style0 from "./EditPriceDlg.vue?vue&type=style&index=0&id=d4375c3e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4375c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4375c3e')) {
      api.createRecord('d4375c3e', component.options)
    } else {
      api.reload('d4375c3e', component.options)
    }
    module.hot.accept("./EditPriceDlg.vue?vue&type=template&id=d4375c3e&scoped=true", function () {
      api.rerender('d4375c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/commodity/dialog/EditPriceDlg.vue"
export default component.exports